import { BrokerId, Coordinates, UUID } from '@trucksmarter/shared';
import { validate } from 'email-validator';
import { UrlObject } from 'url';
import LoadProviderMode from '~/app/(authenticated)/(carrier)/(marketplace)/_ui/LoadProvider/load-provider-mode';

// Broker Portal pages
export const BROKER_PORTAL_SIGNUP_PAGE_PATH = '/broker/signup';
export const BROKER_PORTAL_LOGIN_PAGE_PATH = '/broker/login';
export const BROKER_PORTAL_MY_LOADS_PAGE_PATH = '/broker/my-loads';
export const BROKER_PORTAL_ADD_LOADS_TMS_PAGE_PATH = '/broker/add-loads/tms';
export const BROKER_PORTAL_ADD_LOADS_CSV_PAGE_PATH = '/broker/add-loads/csv';
export const BROKER_PORTAL_ADD_LOADS_API_PAGE_PATH = '/broker/add-loads/api';
export const BROKER_PORTAL_ADD_LOADS_MANUAL_PAGE_PATH =
  '/broker/add-loads/manual';
export const BROKER_PORTAL_PROFILE_PAGE_PATH = '/broker/profile';
export const AUTHENTICATED_BROKER_HOME_PAGE_PATH =
  BROKER_PORTAL_MY_LOADS_PAGE_PATH;

export const AUTH_LOGIN_PAGE_PATH = '/login';
export const AUTH_LOGIN_EMAIL_AND_PASSWORD_PAGE_PATH =
  '/login/email-and-password';
export const AUTH_LOGOUT_PAGE_PATH = '/logout';
export const AUTH_SIGNUP_PAGE_PATH = '/signup';
export const AUTH_VERIFY_EMAIL_ADDRESS_PAGE_PATH = '/verify/email';
export const AUTH_VERIFY_MOBILE_PHONE_NUMBER_PAGE_PATH = '/verify/mobile-phone';
// Adding more query parameters to this redirect path without
// updating stytch.com/dashboard/redirect-urls will cause the OAuth
// redirect to fail. Please be careful when supplying the OAuth redirect
// URL to Stytch.
export const AUTH_OAUTH_REDIRECT_PATH = '/oauth/redirect';
export const AUTH_OAUTH_GOOGLE_CONNECTION_PERMISSION_DENIED_PATH =
  '/oauth/google/permission-denied';
export const AUTH_SIGNUP_FINISH_PAGE_PATH = '/signup/finish';
export const AUTH_RESET_PASSWORD_PAGE_PATH = '/reset-password';
export const AUTH_UPDATED_PASSWROD_PAGE_PATH = '/update-password';
export const REFERRALS_APP_DOWNLOAD_PAGE_PATH = '/referrals/app-download';
export const LOAD_BOARD_PAGE_PATH = '/loadboard';
export const LOAD_BOARD_NEW_SEARCH_PAGE_PATH = '/loadboard/new';
export const MY_LOADS_BIDS_PAGE_PATH = '/my-loads/bids';
export const MY_LOADS_BOOKED_PAGE_PATH = '/my-loads/booked';
export const MY_LOADS_SAVED_PAGE_PATH = '/my-loads/saved';
export const MY_LOADS_RECENTLY_VIEWED_PAGE_PATH = '/my-loads/recently-viewed';
export const BANKING_OTP_VERIFICATION_PATH = '/banking/verify';
export const BANKING_TAX_FORMS = '/banking/tax-forms';
export const FUEL_PAGE_PATH = '/fuel';
export const FACTORING_PAGE_PATH = '/factoring';
export const FACTORING_INVOICES_PAGE_PATH = '/factoring/invoices';
export const FACTORING_INVOICE_SUBMISSION_PAGE_PATH = '/factoring/invoices/new';
export const PROFILE_PAYMENT_METHODS_PAGE_PATH = '/profile/payment-methods';
export const PROFILE_PERSONAL_PAGE_PATH = '/profile/personal';
export const PROFILE_LOAD_BOARDS_PAGE_PATH = '/profile/loadboards';
export const AUTHENTICATED_HOME_PAGE_PATH = LOAD_BOARD_NEW_SEARCH_PAGE_PATH;
export const INSIGHTS_PAGE_PATH = '/insights';
export const BROKER_DIRECTORY_PAGE_PATH = '/broker-directory';
export const DISPATCH_HOME_PAGE_PATH = '/dispatch';
export const DISPATCH_LOAD_PAGE_PATH_PREFIX = '/dispatch/loads';

export function getResetPasswordPageUrlObject(email: string): UrlObject {
  return {
    pathname: AUTH_RESET_PASSWORD_PAGE_PATH,
    query: {
      ...(validate(email) ? { email } : {}),
    },
  };
}

export function getLoadDetailsPageUrlObject(
  loadId: UUID,
  mode?: LoadProviderMode,
): UrlObject {
  return {
    pathname: `/load/${loadId}`,
    query: {
      ...(mode === LoadProviderMode.Archive ? { mode } : {}),
    },
  };
}

export function getPublicLoadDetailsPageUrl(loadId: UUID): string {
  return `${location.origin}/load/${loadId}/public`;
}

export function getReferralSignupPageUrlObject(
  referralCode?: string,
): UrlObject {
  return {
    pathname: AUTH_SIGNUP_PAGE_PATH,
    query: {
      ...(referralCode ? { referralCode } : {}),
    },
  };
}

export function getBrokerDetailsPageUrl(brokerId: BrokerId): string {
  return `${BROKER_DIRECTORY_PAGE_PATH}/${brokerId.replaceAll('_', '-')}`;
}

export function getFuelPageUrlObject({
  loadId,
  stops,
}: {
  loadId?: UUID;
  stops: Coordinates[];
}) {
  return {
    pathname: FUEL_PAGE_PATH,
    query: {
      ...(loadId ? { loadId } : {}),
      stops: encodeURIComponent(
        JSON.stringify(
          stops.map(({ latitude, longitude }) => [latitude, longitude]),
        ),
      ),
    },
  };
}

export function getFactoringInvoiceDetailsPageUrl(invoiceId: UUID): string {
  return `${FACTORING_INVOICES_PAGE_PATH}/${invoiceId}`;
}

export function getDispatchHomePageUrl(): string {
  return DISPATCH_HOME_PAGE_PATH;
}

export function getDispatchLoadPageUrl(loadId: UUID): string {
  return `${DISPATCH_LOAD_PAGE_PATH_PREFIX}/${loadId}`;
}
